module.exports = __webpack_public_path__ + "img/brand.c0b23256.png";